import AppConstants from '../config/app.constants';

let WindowService = function ($http, $q) {

    let all = (offset, limit) => {
        return $http
            .get(AppConstants.api + `/window`, {
                params: {
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/window/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let remove = (id) => {
        return $http
            .delete(AppConstants.api + `/window/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/window/${id}`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/window/${id}`)
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        remove,
        update,
        get
    };
};

WindowService.$inject = ['$http', '$q']

export default WindowService;


// WEBPACK FOOTER //
// ./client/app/services/window.service.js